import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "things" }
const _hoisted_2 = { class: "indented" }
const _hoisted_3 = { class: "indented" }
const _hoisted_4 = { class: "indented" }
const _hoisted_5 = { class: "indented" }
const _hoisted_6 = { class: "indented" }
const _hoisted_7 = { class: "indented" }
const _hoisted_8 = { class: "indented" }
const _hoisted_9 = { class: "indented" }
const _hoisted_10 = { class: "indented" }
const _hoisted_11 = { class: "indented" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("h1", null, _toDisplayString(_ctx.$t("pages.Things.pageTitle")), 1),
    _createElementVNode("p", null, _toDisplayString(_ctx.$t("pages.Things.thisWebsite")), 1),
    _createElementVNode("p", _hoisted_2, [
      _createTextVNode(" - " + _toDisplayString(_ctx.$t("pages.Things.code")) + " ", 1),
      _cache[0] || (_cache[0] = _createElementVNode("a", {
        href: "https://github.com/jteration/jaysull2",
        rel: "noopener noreferrer",
        target: "_blank"
      }, "https://github.com/jteration/jaysull2", -1))
    ]),
    _createElementVNode("p", _hoisted_3, [
      _createTextVNode(" - " + _toDisplayString(_ctx.$t("pages.Things.hosted")) + " ", 1),
      _cache[1] || (_cache[1] = _createElementVNode("a", {
        href: "https://www.jaysull.dev/",
        rel: "noopener noreferrer",
        target: "_blank"
      }, "https://www.jaysull.dev/", -1))
    ]),
    _createElementVNode("p", null, _toDisplayString(_ctx.$t("pages.Things.JSONParser")), 1),
    _createElementVNode("p", _hoisted_4, [
      _createTextVNode(" - " + _toDisplayString(_ctx.$t("pages.Things.code")) + " ", 1),
      _cache[2] || (_cache[2] = _createElementVNode("a", {
        href: "https://github.com/jteration/rs_json",
        rel: "noopener noreferrer",
        target: "_blank"
      }, "https://github.com/jteration/rs_json", -1))
    ]),
    _createElementVNode("p", null, _toDisplayString(_ctx.$t("pages.Things.HTTPParser")), 1),
    _createElementVNode("p", _hoisted_5, [
      _createTextVNode(" - " + _toDisplayString(_ctx.$t("pages.Things.code")) + " ", 1),
      _cache[3] || (_cache[3] = _createElementVNode("a", {
        href: "https://github.com/jteration/rs_http",
        rel: "noopener noreferrer",
        target: "_blank"
      }, "https://github.com/jteration/rs_http", -1))
    ]),
    _createElementVNode("p", null, _toDisplayString(_ctx.$t("pages.Things.cityBlock")), 1),
    _createElementVNode("p", _hoisted_6, [
      _createTextVNode(" - " + _toDisplayString(_ctx.$t("pages.Things.code")) + " ", 1),
      _cache[4] || (_cache[4] = _createElementVNode("a", {
        href: "https://github.com/jteration/city-block",
        rel: "noopener noreferrer",
        target: "_blank"
      }, "https://github.com/jteration/city-block", -1))
    ]),
    _createElementVNode("p", _hoisted_7, [
      _createTextVNode(" - " + _toDisplayString(_ctx.$t("pages.Things.hosted")) + " ", 1),
      _cache[5] || (_cache[5] = _createElementVNode("a", {
        href: "https://jteration.github.io/city-block",
        rel: "noopener noreferrer",
        target: "_blank"
      }, "https://jteration.github.io/city-block", -1))
    ]),
    _createElementVNode("p", null, _toDisplayString(_ctx.$t("pages.Things.capsaicinClicker")), 1),
    _createElementVNode("p", _hoisted_8, [
      _createTextVNode(" - " + _toDisplayString(_ctx.$t("pages.Things.code")) + " ", 1),
      _cache[6] || (_cache[6] = _createElementVNode("a", {
        href: "https://github.com/jteration/capsaicin-clicker",
        rel: "noopener noreferrer",
        target: "_blank"
      }, "https://github.com/jteration/capsaicin-clicker", -1))
    ]),
    _createElementVNode("p", _hoisted_9, [
      _createTextVNode(" - " + _toDisplayString(_ctx.$t("pages.Things.hosted")) + " ", 1),
      _cache[7] || (_cache[7] = _createElementVNode("a", {
        href: "https://jteration.github.io/capsaicin-clicker",
        rel: "noopener noreferrer",
        target: "_blank"
      }, "https://jteration.github.io/capsaicin-clicker", -1))
    ]),
    _createElementVNode("p", null, _toDisplayString(_ctx.$t("pages.Things.horizonHills")), 1),
    _createElementVNode("p", _hoisted_10, [
      _createTextVNode(" - " + _toDisplayString(_ctx.$t("pages.Things.code")) + " ", 1),
      _cache[8] || (_cache[8] = _createElementVNode("a", {
        href: "https://github.com/jteration/horizon-hills",
        rel: "noopener noreferrer",
        target: "_blank"
      }, "https://github.com/jteration/horizon-hills", -1))
    ]),
    _createElementVNode("p", _hoisted_11, [
      _createTextVNode(" - " + _toDisplayString(_ctx.$t("pages.Things.hosted")) + " ", 1),
      _cache[9] || (_cache[9] = _createElementVNode("a", {
        href: "https://jteration.github.io/horizon-hills",
        rel: "noopener noreferrer",
        target: "_blank"
      }, "https://jteration.github.io/horizon-hills", -1))
    ])
  ]))
}